import type { ReactNode } from 'react'

function ItemCount({ children }: { children: ReactNode }): ReactNode {
  return (
    <div className="rounded-full border border-solid border-text-primary/30 px-2.5 py-0.5 text-xs">
      <b className="text-brand-primary">{children}</b>
    </div>
  )
}

export default ItemCount
